import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function VendorListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
